import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Survey_Answer_Kind } from 'generated/types';
import { Form } from 'antd';
import { TextArea, InputNumber, Input } from 'ui/styled';
import { formatMoney, parseMoney } from 'utils/helpers';
import InputField from './InputField';
import Height from './Height';
import DateField from './DateField';
import { numericRule, requiredMessage, getValidNumericValue } from '../helpers/formHelpers';
var EditableAnswerField = function (_a) {
    var kind = _a.kind, required = _a.required, answer = _a.answer, onInputChange = _a.onInputChange, isHidden = _a.isHidden, _b = _a.isTicketSurvey, isTicketSurvey = _b === void 0 ? false : _b;
    var form = Form.useFormInstance();
    var isSurveyRequired = isTicketSurvey && required;
    var onNumericChange = function (event) {
        var value = event.target.value;
        if (value === '' && !required) {
            onInputChange('');
            return;
        }
        var result = getValidNumericValue(value);
        if (result !== null)
            onInputChange(result);
    };
    if (!answer || isHidden)
        return null;
    if (kind === Survey_Answer_Kind.Height) {
        return _jsx(Height, { onInputChange: onInputChange, id: answer.id });
    }
    if (kind === Survey_Answer_Kind.Date) {
        return (_jsx(DateField, { onInputChange: onInputChange, id: answer.id, placeholder: answer.title, required: required, isTicketSurvey: isTicketSurvey }));
    }
    if (kind === Survey_Answer_Kind.Text) {
        return (_jsx(Form.Item, { name: answer.id, rules: [
                {
                    required: isSurveyRequired,
                    message: requiredMessage
                }
            ], children: _jsx(TextArea, { onChange: function (e) { return onInputChange(e.target.value); }, placeholder: answer.title, "data-test": "InputString_".concat(answer.id), autoSize: true }) }));
    }
    if (kind === Survey_Answer_Kind.Money) {
        return (_jsx(Form.Item, { name: answer.id, children: _jsx(InputNumber, { min: 0, max: 1000000, formatter: function (value) { var _a; return formatMoney((_a = value === null || value === void 0 ? void 0 : value.toString()) !== null && _a !== void 0 ? _a : ''); }, onChange: function (value) { var _a; return onInputChange((_a = value === null || value === void 0 ? void 0 : value.toString()) !== null && _a !== void 0 ? _a : ''); }, parser: function (value) { return parseMoney(value !== null && value !== void 0 ? value : ''); }, placeholder: answer.title, "data-test": "InputString_".concat(answer.id) }) }));
    }
    if (kind === Survey_Answer_Kind.Numeric) {
        return (_jsx(Form.Item, { name: answer.id, rules: [
                {
                    required: isSurveyRequired,
                    message: requiredMessage
                },
                numericRule
            ], children: _jsx(Input, { onFocus: function () { return form.validateFields([answer.id]).catch(function () { }); }, onChange: onNumericChange, placeholder: answer.title, "data-test": "InputString_".concat(answer.id) }) }));
    }
    return (_jsx(InputField, { id: answer.id, placeholder: answer.title, onInputChange: onInputChange, inputType: kind, required: required, isTicketSurvey: isTicketSurvey }));
};
export default EditableAnswerField;
